import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "store";
import { AppMessageProvider } from "components";

const root = ReactDOM.createRoot(
  document.getElementById("cms") as HTMLElement
);
root.render(
  <Provider store={store}>
    <AppMessageProvider>
      <App />
    </AppMessageProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
